import { render, staticRenderFns } from "./PosPage.vue?vue&type=template&id=c5fccd10&"
import script from "./PosPage.vue?vue&type=script&lang=js&"
export * from "./PosPage.vue?vue&type=script&lang=js&"
import style0 from "./PosPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports